import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { useIsTipEnabled } from 'reservations/account/providers/ConfigProvider';
import { useIsTipEditablePostClose } from 'reservations/account/providers/ConfigProvider';
import { usePreAuthFinePrint } from 'reservations/account/providers/ConfigProvider';
import { ModalType, useModal } from 'reservations/base/providers/ModalProvider';
import {
  useBookingChecklessPayment,
  useBookingPaymentMethod
} from 'reservations/booking/providers/BookingProvider';
import { GRATUITY_HELPER } from 'reservations/checklessPayments/constants';
import { getReadableCardType } from 'reservations/payments/helpers/getReadableCardType';

const ChecklessPaymentsEnrollmentDetails = () => {
  const { cardType, cardLast4 } = useBookingPaymentMethod();
  const { open } = useModal();
  const { tipPercentage } = useBookingChecklessPayment();
  const isTipEnabled = useIsTipEnabled();
  const isTipEditablePostClose = useIsTipEditablePostClose();

  return (
    <Box mt="1rem">
      <Box display="grid" gap="6px">
        <Typography variant="h3" fontSize={16} fontWeight={300}>
          PAYMENT METHOD
        </Typography>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          <Typography fontSize={17} fontWeight={400}>
            {getReadableCardType(cardType)} {cardLast4}
          </Typography>
          <Typography
            data-testid="update-card-action"
            sx={{
              textDecoration: 'underline',
              textUnderlineOffset: '4px',
              cursor: 'pointer'
            }}
            onClick={() => open(ModalType.ChecklessUpdateCard)}
          >
            UPDATE
          </Typography>
        </Box>
        <Box>
          <Typography
            fontSize={14}
            sx={{
              textDecoration: 'underline',
              textUnderlineOffset: '4px',
              cursor: 'pointer'
            }}
            onClick={() => open(ModalType.ChecklessRemoveCard)}
          >
            REMOVE CARD
          </Typography>
        </Box>
        <Box>
          <Typography fontSize={12}>{usePreAuthFinePrint()}</Typography>
        </Box>
      </Box>
      {isTipEnabled && (
        <Box marginTop="2rem" display="grid" gap="6px">
          <Typography variant="h3" fontSize={16} fontWeight={300}>
            GRATUITY
          </Typography>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}
          >
            <Typography fontSize={17} fontWeight={400}>
              {`${tipPercentage}%`}
            </Typography>
            <Typography
              data-testid="update-tip-action"
              sx={{
                textDecoration: 'underline',
                textUnderlineOffset: '4px',
                cursor: 'pointer'
              }}
              onClick={() => open(ModalType.ChecklessUpdateTip)}
            >
              UPDATE
            </Typography>
          </Box>
          {isTipEditablePostClose && (
            <Box>
              <Typography fontSize={12} maxWidth="100%">
                {GRATUITY_HELPER}
              </Typography>
            </Box>
          )}
        </Box>
      )}
    </Box>
  );
};

export default ChecklessPaymentsEnrollmentDetails;
